import React from 'react'
import { Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import './Team.css'

const { Title, Paragraph } = Typography

const members = [
    {
        name: 'Lucas',
        roleKey: 'coFounder',
        cityKey: 'cologne',
        image: '/img/Lucas.jpg',
    },
    {
        name: 'Felipe',
        roleKey: 'coFounder',
        cityKey: 'munich',
        image: '/img/Felipe.jpg',
    },
    {
        name: 'Gabriel',
        roleKey: 'organizerCityManager',
        cityKey: 'dusseldorf',
        image: '/img/Gabriel.jpg',
    },
    {
        name: 'Julio',
        roleKey: 'organizerDeveloper',
        cityKey: 'munich',
        image: '/img/Julio.jpeg',
    },
    {
        name: 'Leila',
        roleKey: 'organizer',
        cityKey: 'bonn',
        image: '/img/Leila.jpg',
    },
    {
        name: 'Rene',
        roleKey: 'organizer',
        cityKey: 'munich',
        image: '/img/Rene.jpeg',
    },
]

const Team: React.FC = () => {
    const { t } = useTranslation()

    return (
        <>
            <Title className="title team" level={3}>
                {t('about.team.title')}
            </Title>
            <div className="team-wrapper">
                {members.map((member) => (
                    <div key={member.name} className="team-member-card">
                        <img
                            className="team-member-image"
                            src={member.image}
                            alt={member.name}
                        />
                        <div className="team-member-info">
                            <Title className="title team-member-name" level={4}>
                                {member.name}
                            </Title>
                            <Paragraph className="team-member-extra">
                                {t(`about.team.roles.${member.roleKey}`)}
                            </Paragraph>
                            <Paragraph className="team-member-extra">
                                {t(`about.team.cities.${member.cityKey}`)}
                            </Paragraph>
                        </div>
                    </div>
                ))}
            </div>
        </>
    )
}

export default Team
